<template>
  <div class="container">

    <div v-if="isTransmitting">
      <div class="alert alert-info" role="alert">
        <h4 class="alert-heading">Transmitting Order...</h4>
        <p>Please wait while we process the order data, generate & send the required emails.</p>
      </div>
    </div>

    <div v-if="!isSuccess && !isTransmitting && isError">
      <div class="alert alert-danger" role="alert">
        <h4 class="alert-heading">An Error Occurred</h4>
        <p>There was an issue processing your request.</p>
        <p>Please submit a support request including your name and the date & time this occurred.<a
            href="mailto:technical@daylongdirect.co.uk">technical@daylongdirect.co.uk</a></p>
      </div>
    </div>

    <div v-if="isSuccess">
      <div class="alert alert-success" role="alert">
        <h4 class="alert-heading">Order Sent Successfully!</h4>
        <p>Now that we have the details we will place the order in our system and begin processing it.</p>
        <hr>
        <p class="mb-0">If there are any queries with the order we will contact the relevant party using the
          contact methods provided.</p>
      </div>
      <button class="form-start-again" @click.prevent="startAgain">
        <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.651 7.65a7.131 7.131 0 0 0-12.68 3.15M18.001 4v4h-4m-7.652 8.35a7.13 7.13 0 0 0 12.68-3.15M6 20v-4h4"/>
        </svg>
        Start again
      </button>
    </div>

  </div>
</template>

<script>
import postForm from "@/services/post-form";
import initialFormData from "../initialFormData";

export default {
  name: "ForwardOrderSuccess",
  props: {
    value: {
      type: Object,
      default: initialFormData
    },
    recaptchaToken: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      key: '',
      isTransmitting: true,
      isSuccess: false,
      isError: true
    }
  },
  methods: {
    startAgain: function () {
      window.location.reload();
    }
  },
  async mounted() {
    try {
      const {data: {key}} = await postForm('FORWARD_ORDER', {...this.value, recaptchaToken: this.recaptchaToken});
      this.key = key;
      this.isSuccess = true;
    } catch (err) {
      this.isError = true;
    } finally {
      this.isTransmitting = false;
    }
  }
}
</script>

<style lang="scss" scoped>

hr {
  margin-top: 0;
  margin-bottom: 0;
}

.form-start-again {
  background: #00477f;
  border-radius: 3px !important;
  border-color: #00477f;
  font-weight: 600;
  color: #ffffff;
  border-style: solid;
  display: inline-block;
  padding: 0 0.4em;

  &:hover {
    opacity: 0.75;
  }
}
</style>
